<template>
  <div>
    <NewsInfo :queryId="infoId" />
  </div>
</template>

<script>
import NewsInfo from "@/components/NewsInfo.vue";
export default {
  name: "Info",
  components: {
    NewsInfo,
  },
  data() {
    return {
      infoId: null
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newVal) {
        if (newVal?.params?.infoId) {
          this.infoId = newVal.params.infoId
        } else {
          this.infoId = null
        }
      },
    }
  },
}
</script>

<style lang="scss" scoped>

</style>